const data = [
  {
    id: 1,
    image: "/images/memories-creator.png",
    alt: "Memories Creator",
    name: "Memories Creator",
    description: "A full stack Mern project, A full functional app where crud operations are performed.",
    stack: "Reactjs, Mongodb, redux-thunk, material-ui",
    link: "https://github.com/Shivamk99/react-memories-creator", 
    github: "https://github.com/Shivamk99/react-memories-creator"
  },
  {
    id: 2,
    image: "/images/movies-info.png",
    alt: "Movies Info App",
    name: "Movies Info",
    description: "It is a movie search app that lets us search for movies by language, runtime, and imdb rating.",
    stack: "Reactjs, redux-thunk, omdb-api, axios",
    link: "https://shivamk99.github.io/movies-info/", 
    github: "https://github.com/Shivamk99/movies-info"
  },
  {
    id: 3,
    image: "/images/buscation.png",
    alt: "Travel Advisor",
    name: "Travel Advisor",
    description: "This app gives you hotel, restaurant and weather ratings, plus the ability to search for locations.",
    stack: "Reactjs, google-cloud, react-google, material ui",
    link: "https://mapadvisor.netlify.app/", 
    github: "https://github.com/Shivamk99/react-travel-advisor"
  },
  {
    id: 4,
    image: "/images/covid-tracker.png",
    alt: "COVID Tracker",
    name: "COVID Tracker",
    description: "Covid tracker app gives details of infected and dead people",
    stack: "Reactjs, react-chartjs-2, axios, chart.js",
    link: "https://react-covid-19-tracker-application.netlify.app/", 
    github: "https://github.com/Shivamk99/COVID-19-Tracker"
  },
  {
    id: 5,
    image: "/images/well-wisher-card.png",
    alt: "well-wisher-card",
    name: "Well Wisher Card",
    description: "It is a greeting card, where you can send a wish to someone you care about.",
    stack: "Reactjs, p5",
    link: "https://well-wisher-card.netlify.app/", 
    github: "https://github.com/Shivamk99/well-wisher-card"
  },
  {
    id: 6,
    image: "/images/booklist-app.png",
    alt: "Booklisting",
    name: "Booklist App",
    description: "The book-listing app uses vanilla.js to add books, list them, and delete them.",
    stack: "vanilla-js, bootswatch",
    link: "https://keetab-list.netlify.app/", 
    github: "https://github.com/segunajibola/twitter-portfolio"
  },
  
]

export default data;
